// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin:0;padding:0;overflow-y:scroll}.body-overlay{overflow:hidden;cursor:default}", ""]);
// Exports
module.exports = exports;
